import React, { FC } from 'react';
import { BoxProps } from '../../layout/Box';
import { FixedContainer } from './styles';

export const PostProductsFixedContainer: FC<BoxProps> = (props) => <FixedContainer {...props} />;
